module.exports = __webpack_public_path__ + "img/student.f6e9d3a5.gif";